var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.8h4.764a2 2 0 0 1 1.789 2.894l-3.5 7a2 2 0 0 1-1.79 1.106h-4.017c-.163 0-.326-.02-.485-.06L7 20.8v-9l3.392-5.089A3.617 3.617 0 0 0 11 4.704c0-.5.405-.904.904-.904H12a2 2 0 0 1 2 2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.8h4.764a2 2 0 0 1 1.789 2.894l-3.5 7a2 2 0 0 1-1.79 1.106h-4.017c-.163 0-.326-.02-.485-.06L7 20.8m7-10v-5a2 2 0 0 0-2-2h-.096c-.499 0-.904.405-.904.904 0 .715-.211 1.413-.608 2.007L7 11.8v9m7-10h-2m-5 10H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2.5",
    stroke: "#4318ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEmpty);
export default __webpack_public_path__ + "static/media/like-empty.b43ab2027fcb48bf032bae475ed65dda.svg";
export { ForwardRef as ReactComponent };